import axios from 'axios'
import {Message} from 'element-ui'

const service = axios.create({
  baseURL: "http://8.131.229.55:5447" // http://8.131.229.55:5447    http://10.0.0.25:5447
})

axios.defaults.timeout = 30
axios.defaults.timeoutErrorMessage = 'axios  timeout'

service.interceptors.response.use(
  response => {
    const res = response.data
    console.log("res:", res)
    if (res.code !== 0) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export function post(url, data, config = {}) {
  return service({
    url: url,
    method: 'post',
    data: data,
    timeout: config.timeout,
    config: config
  })
}

export function get(url, data, config = {}) {
  return service({
    url: url,
    method: 'get',
    data: data,
    timeout: config.timeout,
    config: config
  })
}
export default service
